<template>
<!--内容管理-->
  <div id="contentManger" style="padding-bottom: 10px">
    <div class="allMenuHead">
      <!--<div :style="{'left': returnStrp(step)}"  class="moveLine p_a"></div>-->
      <div v-if="$childMenu.indexOf('草稿箱') >= 0" :class="step === 1 ? 'active' : ''" @click="toUrl('contenList', 1)" class="d_i headTab p_r">草稿箱<div class="p_a"></div></div>
      <!-- <div :class="step === 2 ? 'active' : ''" @click="toUrl('ContentRelease', 2)"  class="d_i headTab p_r">内容发布<i v-if="ContentReleaseNumber !== 0" class="digitalDote">{{ContentReleaseNumber}}</i><div class="p_a"></div></div> -->
      <div v-if="$childMenu.indexOf('全部内容') >= 0" :class="step === 2 ? 'active' : ''" @click="toUrl('contentReadAll', 2)"  class="d_i headTab p_r">全部内容<i v-if="ContentReleaseNumber !== 0" class="digitalDote">{{ContentReleaseNumber}}</i><div class="p_a"></div></div>

      <div v-if="$childMenu.indexOf('BU-Brand配置') >= 0" @click="toUrl('buBrandList', 6)" :class="step === 6 ? 'active' : ''" class="d_i headTab p_r">BU-Brand配置<div class="p_a"></div></div>

      <div v-if="$childMenu.indexOf('产品组管理') >= 0" :class="step === 3 ? 'active' : ''" @click="toUrl('productList', 3)" class="d_i headTab p_r">产品组管理<div class="p_a"></div></div>
      <div v-if="$childMenu.indexOf('分类管理') >= 0" :class="step === 4 ? 'active' : ''" @click="toUrl('categoryNewList', 4)" class="d_i headTab p_r">分类管理<div class="p_a"></div></div>
      <div v-if="$childMenu.indexOf('文章编辑记录') >= 0" :class="step === 5 ? 'active' : ''" @click="toUrl('contenOperateLog', 5)" class="d_i headTab p_r">文章编辑记录<div class="p_a"></div></div>

      <div v-if="$childMenu.indexOf('内容生命周期动态页面') >= 0" @click="toUrl('lifecyclePage', 7)" :class="step === 7 ? 'active' : ''" class="d_i headTab p_r">内容生命周期动态页面<div class="p_a"></div></div>
      <!-- <div :class="step === 3 ? 'active' : ''" @click="toUrl('commentList', 3)"  class="d_i headTab p_r">评论管理<i v-if="UnReviewCount !== 0" class="digitalDote">{{UnReviewCount}}</i><div class="p_a"></div></div>
      <div :class="step === 4 ? 'active' : ''" @click="toUrl('MaterialLibrary', 4)"  class="d_i headTab p_r">素材库<div class="p_a"></div></div> -->
      <!--<logName class="allLoginNamePlace"></logName>-->
    </div>
    <div class="allHeaderRouter">
      <transition name="fadeLeft">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
let Time
let reflashTime
export default {
  name: 'contentManger',
  data () {
    return {
      step: 1,
      ContentReleaseNumber: '',
      UnReviewCount: '',
      size: 1,
      showMenu: true,
      appowner: JSON.parse(window.sessionStorage.getItem('nowApp')),
      isAdmin: window.localStorage.getItem('isAdmin')
    }
  },
  created () {
    if (window.screen.width < 1400) {
      this.size = 0.92
    }
    console.log(this.size)
    // this.getApprovalPendingCount()
    // this.getUnReviewCount()
    Time = setInterval(p => {
      if (window.location.href.indexOf('contenList') >= 0) {
        this.step = 1
      } else if (window.location.href.indexOf('contentReadAll') >= 0) {
        this.step = 2
      } else if (window.location.href.indexOf('productList') >= 0) {
        this.step = 3
      } else if (window.location.href.indexOf('categoryNewList') >= 0) {
        this.step = 4
      }else if (window.location.href.indexOf('contenOperateLog') >= 0) {
        this.step = 5
      } else if (window.location.href.indexOf('buBrandList') >= 0) {
        this.step = 6
      } else if (window.location.href.indexOf('lifecyclePage') >= 0) {
        this.step = 7
      }
    }, 100)
    reflashTime = setInterval(p => {
      let data = window.sessionStorage.getItem('reflash')
      if (data === 'need') {
        window.sessionStorage.setItem('reflash', '')
        // this.getApprovalPendingCount()
        // this.getUnReviewCount()
      }
    }, 100)
  },
  destroyed () {
    clearInterval(Time)
    clearInterval(reflashTime)
  },
  methods: {
    getApprovalPendingCount () {
      this.$axiox.get('/api/content/publish/approvalPendingCount').then(msg => {
        this.ContentReleaseNumber = msg.result
      })
    },
    getUnReviewCount () {
      this.$axiox.get('/api/content/comment/Manage/UnReviewCount').then(msg => {
        this.UnReviewCount = msg.result
      })
    },
    toUrl (url, num) {
      this.step = num
      this.$router.push(url)
    },
    returnStrp (type) {
      switch (type) {
        case 1:
          return '19px'
        case 2:
          return (118 * this.size) + 'px'
        case 3:
          return (227 * this.size) + 'px'
        case 4:
          return (325 * this.size) + 'px'
      }
      return ''
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/contentManger/contentManger.vue